import { useTranslation } from '@/shared/hooks/useTranslation'
import { Button } from '@/shared/ui/Button'

type QuestRunStepProps = {
  busy?: boolean
  onContinue: () => void
}

export function QuestRunStep({ busy, onContinue }: QuestRunStepProps) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center gap-3 text-center">
      <p className="m-0 text-sm font-bold text-gray-900">{t('quests.run.title')}</p>
      <p className="m-0 text-xs text-gray-500">{t('quests.run.description')}</p>
      <Button variant="primary" size="lg" loading={busy} onClick={onContinue}>
        {t('quests.run.continue')}
      </Button>
    </div>
  )
}
